/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// import ReactDOM from "react-dom/client";

import {render} from "react-dom";
import "assets/plugins/nucleo/css/nucleo.css";
import "assets/css/placeholder.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import App from "App";
import 'assets/css/messenger.css';
import 'assets/css/question-bank-custom.css';
import 'assets/css/pmr-landing.css';
import 'assets/css/muscle-drill.css';

const root = document.getElementById('root');

render(
  <App></App>,
  root
);

